import type { ReactNode } from "react"
import type { Fetchable } from "@/services/utilities/fetchable"

type SwitchFetchableProps<Subject> = {
  readonly fetchable: Fetchable<Subject>
  readonly renderInitial?: () => ReactNode
  readonly renderPending?: () => ReactNode
  readonly renderSucceeded?: (value: Subject | undefined) => ReactNode
  readonly renderFailed?: (errorMessage: string) => ReactNode | null
  readonly renderDefault?: () => ReactNode
}

export function SwitchFetchable<Subject>({
  fetchable,
  renderDefault,
  renderFailed,
  renderInitial,
  renderPending,
  renderSucceeded,
}: SwitchFetchableProps<Subject>) {
  switch (fetchable.class) {
    case "failed":
      return renderFailed?.(fetchable.errorMessage) ?? renderDefault?.() ?? null
    case "initial":
      return renderInitial?.() ?? renderDefault?.() ?? null
    case "pending":
      return renderPending?.() ?? renderDefault?.() ?? null
    case "succeeded":
      return renderSucceeded?.(fetchable.value) ?? renderDefault?.() ?? null
  }
}
